import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@cxagroup/casper";
import CharityContent from "./CharityContent";
class CharityPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { optIn: true, taxDeduction: false, showPopup: this.props.showPopup };
  }

  onSubmit = () => {
    const { getDashboardAndInitNotification, onSubmit } = this.props;
    onSubmit({ answer1: this.state.optIn, answer2: this.state.taxDeduction });
    this.setState({ showPopup: false });
    getDashboardAndInitNotification();
  };
  onOptInSelected = () => {
    this.setState({ optIn: true });
  };
  onNotOptInSelected = () => {
    this.setState({ optIn: false, taxDeduction: false });
  };
  onTaxDeductionChange = () => {
    this.setState({ taxDeduction: !this.state.taxDeduction });
  };
  render() {
    const { showPopup, ...rest } = this.props;
    return (
      <Modal isOpen={this.state.showPopup}>
        <CharityContent
          {...rest}
          {...this.state}
          onSubmit={this.onSubmit}
          onOptInSelected={this.onOptInSelected}
          onNotOptInSelected={this.onNotOptInSelected}
          onTaxDeductionChange={this.onTaxDeductionChange}
        />
      </Modal>
    );
  }
}

CharityPopup.propTypes = {
  showPopup: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  getDashboardAndInitNotification: PropTypes.func.isRequired,
};

export default CharityPopup;



// WEBPACK FOOTER //
// ./components/dashboard/CharityPopup.js